import type { Database } from "@/database.types";
import {
  createClient as createSupabaseClient,
  type SupabaseClient,
} from "@supabase/supabase-js";

let browserClient: SupabaseClient<Database> | undefined;

function createBrowserClient(): SupabaseClient<Database> {
  if (!browserClient) {
    browserClient = createSupabaseClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY!,
      {
        auth: {
          flowType: "implicit",
          detectSessionInUrl: false,
        },
      },
    );
  }

  return browserClient;
}

function createServerClient(): SupabaseClient<Database> {
  return createSupabaseClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY!,
    {
      auth: {
        flowType: "implicit",
        detectSessionInUrl: false,
      },
    },
  );
}

export function createClient(): SupabaseClient<Database> {
  if (typeof window === "undefined") {
    return createServerClient();
  }

  return createBrowserClient();
}
